import Vue from 'vue';
import Spinner from 'vue-simple-spinner';

Vue.component('vue-simple-spinner', Spinner);
